var _circle, _mask, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#F1F1F1",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.259 -3.26857e-08 10.564 0.704149 8.17337 2.04493C5.78272 3.38572 3.7766 5.31817 2.34736 7.65701C0.918119 9.99585 0.113685 12.6626 0.0111903 15.4017C-0.0913049 18.1408 0.511575 20.8602 1.76203 23.2993C3.01248 25.7384 4.86856 27.8154 7.15233 29.3311C9.43609 30.8468 12.0709 31.7504 14.8042 31.9553C17.5375 32.1601 20.2776 31.6593 22.7618 30.501C25.246 29.3426 27.3909 27.5655 28.9909 25.34L27.3801 24.1818C25.9784 26.1313 24.0995 27.6881 21.9233 28.7028C19.7472 29.7176 17.3469 30.1562 14.9525 29.9768C12.5581 29.7973 10.25 29.0058 8.24944 27.6781C6.24887 26.3503 4.62294 24.5309 3.52754 22.3942C2.43215 20.2575 1.90402 17.8753 1.99381 15.4759C2.0836 13.0765 2.78828 10.7404 4.04029 8.69155C5.29231 6.64272 7.04967 4.94989 9.14388 3.77537C11.2381 2.60084 13.5989 1.98401 16 1.98401V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.259 -3.26857e-08 10.564 0.704149 8.17337 2.04493C5.78272 3.38572 3.7766 5.31817 2.34736 7.65701C0.918119 9.99585 0.113685 12.6626 0.0111903 15.4017C-0.0913049 18.1408 0.511575 20.8602 1.76203 23.2993C3.01248 25.7384 4.86856 27.8154 7.15233 29.3311C9.43609 30.8468 12.0709 31.7504 14.8042 31.9553C17.5375 32.1601 20.2776 31.6593 22.7618 30.501C25.246 29.3426 27.3909 27.5655 28.9909 25.34L27.3801 24.1818C25.9784 26.1313 24.0995 27.6881 21.9233 28.7028C19.7472 29.7176 17.3469 30.1562 14.9525 29.9768C12.5581 29.7973 10.25 29.0058 8.24944 27.6781C6.24887 26.3503 4.62294 24.5309 3.52754 22.3942C2.43215 20.2575 1.90402 17.8753 1.99381 15.4759C2.0836 13.0765 2.78828 10.7404 4.04029 8.69155C5.29231 6.64272 7.04967 4.94989 9.14388 3.77537C11.2381 2.60084 13.5989 1.98401 16 1.98401V0Z",
    stroke: "#50949E",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 22.6668C19.6825 22.6668 22.6673 19.6821 22.6673 16.0002C22.6673 12.3183 19.6825 9.3335 16.0007 9.3335C12.3188 9.3335 9.33398 12.3183 9.33398 16.0002C9.33398 19.6821 12.3188 22.6668 16.0007 22.6668Z",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.6667V16",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.3335H16.007",
    stroke: "#32425B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails2);
export default __webpack_public_path__ + "static/media/details2.e7dbdc3e5dd0bb313994db71871b436a.svg";
export { ForwardRef as ReactComponent };